const FEATURE_MELHOR_DROP = 'melhor-drop';

export default {
  FEATURE_MELHOR_DROP,

  methods: {
    feature: (name) => MEFeatureFlag.enabled(name),
  }
};
